<img src="assets/imgs/register.png" width="60" height="60" />
<h1>register</h1>
<br />
<p>your email will not be visible to other users.</p>
<br />
<!-- email/password -->
<kor-input
  label="email"
  type="email"
  name="email"
  (input)="email = $event.target.value"
></kor-input>
<kor-input
  label="password"
  type="password"
  name="password"
  (input)="password = $event.target.value"
></kor-input>
<br />
<kor-input
  label="username"
  type="text"
  name="username"
  (input)="name = $event.target.value"
></kor-input>
<br />
<!-- button -->
<kor-button
  class="stretch"
  label="register"
  (click)="registerUser(); sharedService.logEvent('register_button_clicked')"
  [disabled]="!(name && email && password)"
></kor-button>
<kor-button
  color="secondary"
  class="stretch"
  label="return"
  (click)="return.emit(); sharedService.logEvent('register_return_clicked')"
></kor-button>
